import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import Landing from "./pages/Landing";
import Order from "./pages/Order";
import Checkout from "./pages/Checkout";
import Confirmation from "./pages/Confirmation";
import Kds from "./pages/Kds";
import KdsLogin from "./pages/KdsLogin";
import Kiosk from "./pages/Kiosk";
import Dashboard from "./pages/Dashboard";
import DashboardMenu from "./pages/DashboardMenu";
import Pos from "./pages/Pos";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/order" element={<Order />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/confirmation/:id" element={<Confirmation />} />
            <Route path="/kds" element={<Kds />} />
            <Route path="/kds/login" element={<KdsLogin />} />
            <Route path="/kiosk" element={<Kiosk />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/menu" element={<DashboardMenu />} />
            <Route path="/pos" element={<Pos />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid rgba(57,255,20,0.4)",
            color: "#F3F4F6",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
